import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import "./BudgetLineChart.scss";
import { formatNumber } from "../../../utils/format";

const BudgetLineChart = ({ data, nameline1, nameline2 }) => {
  const formatYAxis = (value) => {
    if (value >= 1000000) {
      return `$${(value / 1000000).toFixed(2)}M`;
    } else if (value >= 1000) {
      return `$${(value / 1000).toFixed(1)}K`;
    } else {
      return `$${value}`;
    }
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="tooltip-container-line-chart-budget">
          <div className="month-years">{label}</div>
          {payload.map((entry, index) => (
            <div key={index}>
              <p className="value-tooltip">
                <strong>{entry.name}:</strong> ${formatNumber(entry.value)}
              </p>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  const formatRevenue = (value) => {
    return `$${Math.round(value / 1000000)}M`;
  };

  const renderLabel = (props) => {
    const { x, y, value, index } = props;
    if (index % 2 === 0 || index === data.length - 1) {
      return (
        <text x={x} y={y - 10} fill="#666" textAnchor="middle" fontSize={12}>
          {formatRevenue(value)}
        </text>
      );
    }
    return null;
  };

  const renderLabel2 = (props) => {
    const { x, y, value, index } = props;
    if (index % 2 === 0 || index === data.length - 1) {
      return (
        <text x={x} y={y + 20} fill="#666" textAnchor="middle" fontSize={12}>
          {formatRevenue(value)}
        </text>
      );
    }
    return null;
  };

  return (
    <div style={{ width: "100%", height: "400px", cursor: "pointer" }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 30 }}
        >
          <CartesianGrid vertical={false} stroke="#f0f0f0" />
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: "#666" }}
          />
          <YAxis
            tickFormatter={formatYAxis}
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: "#666", dx: -20 }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            verticalAlign="top"
            height={36}
            iconType="circle"
            wrapperStyle={{ fontSize: 15, paddingBottom: 60 }}
          />
          <Line
            type="monotone"
            dataKey="budget"
            name={nameline1}
            stroke="#40C9B5"
            strokeWidth={3}
            dot={false}
            activeDot={{ r: 6 }}
            label={renderLabel}
          />
          <Line
            type="monotone"
            dataKey="actual"
            name={nameline2}
            stroke="#A3E4DB"
            strokeWidth={3}
            dot={false}
            activeDot={{ r: 6 }}
            label={renderLabel2}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BudgetLineChart;
